/**
 * @description
 * @author fanzhiwei
 * @param {*} appVersion:当前版本
 * @param {*} [e,f,g]：标准版本
 * @returns Boolean  true:当前版本大于标准版本
 */
function checkVersion(appVersion,[e,f,g]){
  let  [a,b,c] = appVersion.split('.').map((item)=>parseInt(item))
   function temp (){
     if(a>e){
       return true
     }else if(a<e){
       return false
     }else if(b>f){
       return true
     }else if(b<f){
       return false
     }else if (c>g){
       return true
     }else if (c<g){
       return false
     }
     return false
   }
   return temp() || appVersion==[e,f,g].join('.')
}
export default checkVersion